"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.15.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLocaleEnum = void 0;
exports.UserLocaleEnum = {
    CsCz: 'cs-CZ',
    DaDk: 'da-DK',
    DeDe: 'de-DE',
    EnUs: 'en-US',
    EsEs: 'es-ES',
    FiFi: 'fi-FI',
    FrFr: 'fr-FR',
    ItIt: 'it-IT',
    NlNl: 'nl-NL',
    NnNo: 'nn-NO',
    SvSe: 'sv-SE'
};
